export default [{
  name: '是否',
  values: [
    { name: '是', value: 1 },
    { name: '否', value: 0 }
  ]
},
{
  name: '经营类型',
  values: [
    { name: '零售商', value: '1' },
    { name: '批发商', value: '2' }
  ]
},
{
  name: '审核状态',
  values: [
    { name: '禁用', value: 0 },
    { name: '待审核', value: 1 },
    { name: '审核不通过', value: 2 },
    { name: '审核通过', value: 3 }
  ]
},
{
  name: '性别',
  values: [
    { name: '男', value: '男' },
    { name: '女', value: '女' }
  ]
},
{
  name: '类别',
  values: [
    { name: '农药', value: '1' },
    { name: '种子', value: '2' },
    { name: '肥料', value: '3' }
  ]
},
{
  name: '农药类别',
  values: [
    { name: '杀鼠剂', value: '杀鼠剂' },
    { name: '杀虫剂', value: '杀虫剂' },
    { name: '杀菌剂', value: '杀菌剂' },
    { name: '除草剂', value: '除草剂' },
    { name: '植物生长调节剂', value: '植物生长调节剂' },
    { name: '其它', value: '其它' }
  ]
},
{
  name: '包装单位',
  values: [
    { name: '克', value: '克' },
    { name: '毫克', value: '毫克' },
    { name: '升', value: '升' },
    { name: '毫升', value: '毫升' }
  ]
},
{
  name: '包装类型',
  values: [
    { name: '瓶', value: '瓶' },
    { name: '盒', value: '盒' },
    { name: '支', value: '支' },
    { name: '枚', value: '枚' },
    { name: '片', value: '片' },
    { name: '袋', value: '袋' },
    { name: '套', value: '套' },
    { name: '罐', value: '罐' },
    { name: '桶', value: '桶' },
    { name: '包', value: '包' },
    { name: '箱', value: '箱' }
  ]
},
{
  name: '毒性',
  values: [
    { name: '微毒', value: '微毒' },
    { name: '低毒', value: '低毒' },
    { name: '中等毒', value: '中等毒' },
    { name: '高毒', value: '高毒' },
    { name: '剧毒', value: '剧毒' }
  ]
},
{
  name: '登记证状态',
  values: [
    { name: '有效', value: '有效' },
    { name: '无效', value: '无效' }
  ]
},
{
  name: '作物类别',
  values: [
    { name: '小麦', value: '小麦' },
    { name: '水稻', value: '水稻' },
    { name: '玉米', value: '玉米' },
    { name: '油菜', value: '油菜' },
    { name: '棉花', value: '棉花' },
    { name: '大豆', value: '大豆' },
    { name: '蔬菜种子', value: '蔬菜种子' },
    { name: '粮食种子', value: '粮食种子' },
    { name: '林木种子', value: '林木种子' },
    { name: '经济作物种子', value: '经济作物种子' },
    { name: '水果种子', value: '水果种子' },
    { name: '花卉种子', value: '花卉种子' }
  ]
},
{
  name: '产品形态',
  values: [
    { name: '粉剂', value: '粉剂' },
    { name: '颗粒', value: '颗粒' },
    { name: '片状颗粒', value: '片状颗粒' },
    { name: '水剂', value: '水剂' },
    { name: '液体', value: '液体' },
    { name: '柱形颗粒', value: '柱形颗粒' },
    { name: '柱状颗粒', value: '柱状颗粒' }
  ]
},
{
  name: '商品类型',
  values: [
    { name: '生物肥料', value: '生物肥料' },
    { name: '无机肥料', value: '无机肥料' },
    { name: '有机肥料', value: '有机肥料' }
  ]
},
{
  name: '库存预警',
  values: [
    { name: '库存充足', value: '1' },
    { name: '库存不足', value: '2' }
  ]
},
{
  name: '使用方法',
  values: [
    { name: '喷雾', value: '1' },
    { name: '土壤处理', value: '2' },
    { name: '拌种或浸种', value: '3' },
    { name: '喷粉', value: '4' },
    { name: '其他方法', value: '5' }
  ]
},
{
  name: '打印模式',
  values: [
    { name: '预览打印', value: '1' },
    { name: '直接打印', value: '2' }
  ]
},
{
  name: '分析日期',
  values: [
    { name: '近7天', value: '1' },
    { name: '本月', value: '2' }
  ]
},
{
  name: '资讯类别',
  values: [
    { name: '种植技术', value: '1' },
    { name: '土壤肥料', value: '2' },
    { name: '植物保护', value: '3' },
    { name: '养殖技术', value: '4' },
    { name: '疫病防治', value: '5' },
    { name: '动物饲料', value: '6' },
    { name: '农村能源', value: '7' },
    { name: '种草技术', value: '8' },
    { name: '品种资源', value: '9' },
    { name: '科技知识', value: '10' },
    { name: '技术讲座', value: '11' }
  ]
},
{
  name: 'logo显示方式',
  code: 'logoShowWay',
  values: [
    { name: '图片', code: 'IMAGE', value: '0' },
    { name: '文字', code: 'TEXT', value: '1' }
  ]
},
{
  name: '语言切换',
  values: [
    { name: '中文设置', value: '1' },
    { name: '英文设置', value: '2' }
  ]
},
{
  name: '备注选择',
  values: [
    { name: '模板选择', value: '1' },
    { name: '手动输入', value: '2' }
  ]
},
{
  name: '用药事项注意',
  values: [
    { name: '使用本品时应穿戴防护服和手套，避免吸入药液。施药期间不可吃东西和饮水。施药后应及时洗手和洗脸。', value: '1' },
    { name: '清洗施药器械等的污水不可污染地下水源、河塘等各种水域，避免对环境中其它生物造成危害。', value: '2' },
    { name: '孕妇及哺乳期妇女禁止接触本品。', value: '3' },
    { name: '避免与皮肤眼睛接触，防止由口鼻吸入。', value: '4' }
  ]
},
{
  name: '禁限农药是否',
  values: [
    { name: '是', value: '是' },
    { name: '否', value: '否' }
  ]
}
];



// WEBPACK FOOTER //
// ./src/enums/modules/common/index.js